import { sendDelete, sendGet, sendPost, sendPut } from "./axios";

export const getListCustomer = (params) => sendGet("/orders", params);
export const getCountOrders = (params) => sendGet("/orders/count-by-date", params);
export const createOrder = (params) => sendPost("/orders", params);
export const updateOrder = (id, params) => sendPut(`/orders/${id}`, params);
export const deleteOrder = (id) => sendDelete(`/orders/${id}`);
export const deleteMultipleOrders = (params) => sendPost("/orders/delete-multiple", params);
